import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { sortRatePlansByPriority } from "@/helpers/sortRatePlansByPriority.ts";
import { useRef } from "react";

export const useInitialSortedRates = (availableRatePlans: RatePlanMerged[], selectedRateId: string) => {
  const sortedRatesRef = useRef<RatePlanMerged[] | null>(null);

  if (!sortedRatesRef.current && availableRatePlans.length > 0) {
    const sorted = sortRatePlansByPriority(availableRatePlans);
    const selected = sorted.find((rp) => rp.id === selectedRateId);
    const rest = sorted.filter((rp) => rp.id !== selectedRateId);
    sortedRatesRef.current = selected ? [selected, ...rest] : [...sorted];
  }

  return sortedRatesRef.current ?? availableRatePlans;
};
